import React from 'react';

import { LottieView } from '../../../ucl/lib';

import animation from './animations/bk-loader.json';
import {
  OptInDialogBody,
  OptInDialogBodyContent,
  OptInDialogBodyText,
  OptInDialogHeader,
  OptInDialogHeading,
} from './styled';
import type { IOptInLoadingContentProps } from './types';

export const OptInLoadingContent = ({ heading, description }: IOptInLoadingContentProps) => {
  return (
    <>
      <LottieView source={animation} autoPlay style={{ width: '100%' }} />

      <OptInDialogHeader>
        <OptInDialogHeading>{heading}</OptInDialogHeading>
      </OptInDialogHeader>

      <OptInDialogBodyContent>
        <OptInDialogBody>
          <OptInDialogBodyText>{description}</OptInDialogBodyText>
        </OptInDialogBody>
      </OptInDialogBodyContent>
    </>
  );
};
